import {Solicitation, SolicitationFields} from "../../../types/solicitation/solicitationData";
import {TableRow, TableCell, Box, Typography, Chip, Tooltip, Link} from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import {EstadoColorMap} from "../../solicitations/SolicitationPreview";
import { dateFormatter } from "src/utils/formatters";
import {EntityWithIdFields} from "../../../types/baseEntities";
import TaskIcon from '@mui/icons-material/Task';
import {SolicitudPreviewEstados} from "../../solicitations/dummyTypes";
import {useContext} from "react";
import {CompanyContext} from "../../solicitation-new/context/companyContext";
import {useNavigate} from "react-router-dom";


interface SolicitationTableRowProps {
    sol: Solicitation
}


const SolicitationTableRow = ({sol}: SolicitationTableRowProps) => {
    const {setClientSolicitationId} = useContext(CompanyContext)
    const navigate = useNavigate()
    const handleLink = () => {
        setClientSolicitationId(sol[EntityWithIdFields.Id])
        localStorage.setItem('solicitationId', `${sol[EntityWithIdFields.Id]}`)
        if (sol[SolicitationFields.SolicitationStateCode] === SolicitudPreviewEstados.Pendiente) {
            navigate('/solicitudes/nueva-solicitud')
        }else {
            navigate(`/solicitudes/${sol[EntityWithIdFields.Id]}`)
        }
    }
    
    return (
        <TableRow sx={{
            '&:last-child .MuiTableCell-root': { pb: theme => `${theme.spacing(4)} !important` },
            '& .MuiTableCell-root': { border: 0, py: theme => `${theme.spacing(2.5)} !important` }
        }}>
            <TableCell>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Link underline={"none"} sx={{ mb: 0.4, fontWeight: 600, cursor: 'pointer' }} color={'primary'} onClick={handleLink}>
                        {`#${sol[EntityWithIdFields.Id]}`}
                    </Link>
                    <Typography variant='caption'>
                        {
                            sol[SolicitationFields.OperationDestinationReasonDesc] !== null && sol[SolicitationFields.OperationDestinationDesc] !== null ?
                            `${sol[SolicitationFields.OperationDestinationReasonDesc]} (${sol[SolicitationFields.OperationDestinationDesc]})`
                                :
                                '- Destino sin especificar -'
                        }
                    </Typography>
                </Box>
            </TableCell>
            <TableCell>
                <Tooltip title={`Tiene ${sol[SolicitationFields.AchievedDocumentsQuantity]} pedido de documentación anexado de ${sol[SolicitationFields.TotalDocumentsQuantity]}`}>
                    <Chip color={'primary'}
                          icon={<ArticleIcon />}
                          label={`${sol[SolicitationFields.AchievedDocumentsQuantity]}/${sol[SolicitationFields.TotalDocumentsQuantity]}`}
                          size={'small'}
                    />
                </Tooltip>
            </TableCell>
            <TableCell>
                <Tooltip title={`Tiene ${sol[SolicitationFields.CompletedTasksQuantity]} tareas realizadas de ${sol[SolicitationFields.TotalTasksQuantity]}`}>
                    <Chip color={'primary'}
                          icon={<TaskIcon />}
                          label={`${sol[SolicitationFields.CompletedTasksQuantity]}/${sol[SolicitationFields.TotalTasksQuantity]}`}
                          size={'small'}
                    />
                </Tooltip>
            </TableCell>
            <TableCell>
                <Chip
                    label={sol[SolicitationFields.SolicitationStateDesc]}
                    color={EstadoColorMap(sol[SolicitationFields.SolicitationStateCode])}
                    size='small'
                    variant='outlined'
                />
            </TableCell>
            <TableCell>
                <Typography noWrap variant='body2'>
                    {
                        sol[SolicitationFields.SentDate] ? 
                            dateFormatter.toShortDate(sol[SolicitationFields.SentDate])
                            :
                            '- Sin enviar -'
                    }
                </Typography>
            </TableCell>
        </TableRow>
    )
}


export default SolicitationTableRow